import React from "react";
import {startOfMonth} from "date-fns";

import MonthSelector from "../../../components/Planner/MonthSelector";
import {usePlanner} from "../../../components/Planner";
import StyledToggleButtonGroup from "../../../components/StyledToggleButtonGroup";

import Toolbar from "@mui/material/Toolbar";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ToggleButton from "@mui/material/ToggleButton";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";


const TableauToolbar = (props) => {
    const {selectedViewMode, onChangeViewMode} = props;
    const {goToDate} = usePlanner();

    return <Toolbar disableGutters sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        columnGap: '8px',
        mt: 1
    }}>

        <Stack direction="row" spacing={2}>
            <Button variant="text"
                    color='primary'
                    size='small'
                    onClick={() => goToDate(startOfMonth(new Date()))}>Mese corrente</Button>
            <MonthSelector
                renderButton={(props) => (
                    <Button {...props}
                            variant="text"
                            color='primary'
                            size='small'
                            endIcon={<ArrowDropDownIcon/>}>Seleziona mese</Button>)
                }/>
        </Stack>

        <StyledToggleButtonGroup
            value={selectedViewMode}
            exclusive
            onChange={onChangeViewMode}
            aria-label="tableau view mode"
            size="small"
            color="primary"
        >
            <ToggleButton value="timeline" aria-label="timeline">
                <ViewListIcon fontSize="small"/> Timeline
            </ToggleButton>
            <ToggleButton value="month-vertical" aria-label="month vertical">
                <ViewModuleIcon fontSize="small"/> Mese
            </ToggleButton>
        </StyledToggleButtonGroup>

    </Toolbar>
}

export default TableauToolbar;